import { render, staticRenderFns } from "./AntiFraud.vue?vue&type=template&id=0f2018d3&scoped=true"
import script from "./AntiFraud.vue?vue&type=script&lang=js"
export * from "./AntiFraud.vue?vue&type=script&lang=js"
import style0 from "./AntiFraud.vue?vue&type=style&index=0&id=0f2018d3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2018d3",
  null
  
)

export default component.exports